import * as e from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/LinkBreak.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(t, { ref: a, ...r, weights: n }));
o.displayName = "LinkBreakIcon";
const c = o;
export {
  c as LinkBreak,
  o as LinkBreakIcon
};
